<div [@routerTransition] class="height-100pe">
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="row height-100pe">
    <div class="col-md-12">
      <div class="card my-profile-form margin-top-15px top-link">
        <div class="card-header wh-header padding-bottom-6px">
          <div class="row">
            <div class="col-md-12">
              Expense Management Report
            </div>
            
          </div>
          <div class="row">
            <div class="col-md-12 padding-right-0px">
              <div class="row">
                <div class="max-width-9pe col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">Facility :</label>
                </div>
                <div class="max-width-9pe padding-left-0px">
                  <div class="form-group margin-bottom-0px">
                    <CustomDataByRequestType RequestedType="FacilityList" ActorCode={{ActorCode}}
                                             (keyChange)="Roleassign($event)"
                                             [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode"
                                             required>
                    </CustomDataByRequestType>
                    <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                    <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


                  </div>
                </div>

                <div class="max-width-6pe col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">From :</label>
                </div>
                <div class="max-width-9pe padding-left-0px">
                  <div class="date-form">
                    <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                           (ngModelChange)="dataChanged($event)">

                    <a (click)="d.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>
                </div>
                <div class="max-width-6pe col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">To :</label>
                </div>
                <div class="max-width-9pe padding-left-0px">
                  <div class="date-form">
                    <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFromDate" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker"
                           (ngModelChange)="dataChanged($event)">

                    <a (click)="d1.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>
                </div>
                <div class="max-width-10pe col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">Claim Status :</label>
                </div>
                <div class="max-width-9pe padding-left-0px">
                  <div class="form-group margin-bottom-0px">
                    <CodeTypeValue CodeType="Claim"></CodeTypeValue>
                    <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
      [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
      name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                    <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


                  </div>
                </div>
                <div class="max-width-10pe col-sm-3 padding-right padding-left-0px text-align-right margin-top-3px">
                  <label class="margin-right-3px margin-bottom-0px font-size-16px">Payment Type :</label>
                </div>
                <div class="max-width-9pe padding-left-0px">
                  <div class="form-group margin-bottom-0px">
                    <CodeTypeValue CodeType="PYTMD"></CodeTypeValue>
                    <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
      [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
      name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                    <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->


                  </div>
                </div>

                <!--<div class="col-md-3 float-right padding-right-0px padding-l-0px display-inherit">
    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

  </div>-->
                <div class="max-width-12pe padding-left-0px">
                  <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-10px" (click)="Go()">Go</button>
                  <button class="btn font-size-13px actions-btn-prime  margin-left-5px" title="print" (click)="printexpenses()">GetReport</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body padding-top-0px margin-left-0px">
          <div class="row">
            <div class="offset-md-10 col-md-2">
              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero width-100pe"
                         cols="auto,2*,*,*,*,*,*,*">
                    
                    <thead class="">
                      <tr>

                        <th class="min-width-24px padding-top-4px padding-bottom-4px">
                          VoucherNo
                        </th>
                        <!--<th class="text-align-center">Day</th>-->
                        <!--<th class="text-align-center">
    Old Reg No
  </th>-->
                        <th class="padding-top-4px padding-bottom-4px">
                          Date
                        </th>
                        <!--<th class="text-align-center">Start Time</th>-->
                        <th class="padding-top-4px padding-bottom-4px">
                          Name
                        </th>

                        <!--<th class="">
    Prime Relation
  </th>-->

                        <th class="padding-top-4px padding-bottom-4px">
                          Purpose
                        </th>
                        <th class="padding-top-4px padding-bottom-4px padding-right-5px">
                          Amount
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Payment Type
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Approved By
                        </th>
                        <th class="padding-top-4px padding-bottom-4px">
                          Facility Name
                        </th>

                        <th class="padding-top-4px padding-bottom-4px">
                        
                        </th>




                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of pdata">

                        <td class="td-padding-tb">{{l.VoucherNo}}</td>


                        <td class=" td-padding-tb">{{l.ReceiptDate| date:'MMM-dd-yyyy'}}</td>


                        <td class=" td-padding-tb">
                          {{l.EmployeeName}}
                        </td>



                        <td class="td-padding-tb">{{l.Towards}}</td>

                        <td class="td-padding-tb  text-align-center padding-right-0px">{{l.TotalAmount}}</td>
                        <td class="td-padding-tb  ">{{l.PaymentInstrument}}</td>
                        <td class="td-padding-tb  ">{{l.EmployeeName}}</td>
                        <td class="td-padding-tb "></td>
                        <td class="td-padding-tb ">
                          <button type="button" (click)="ViewItem(l)" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime-man actions-btn-prime3 margin-left-auto font-size-13px padding-left-5px padding-right-5px min-width-32px">
                            <i class="fa fa-ellipsis-h"></i>
                          </button>
                          <button class="btn font-size-13px actions-btn-prime  margin-left-5px">Cancel Voucher</button>

                        </td>





                      </tr>
                      <!--<tr>

                        <td class="td-padding-tb">GGH0</td>


                        <td class=" td-padding-tb">19</td>


                        <td class=" td-padding-tb">
                         Sham
                        </td>



                        <td class="td-padding-tb">one</td>

                        <td class="td-padding-tb  text-align-center padding-right-0px">100</td>
                        <td class="td-padding-tb  ">cash</td>
                        <td class="td-padding-tb  ">hari</td>
                        <td class="td-padding-tb ">service</td>
                        <td class="td-padding-tb ">
                          <button type="button" (click)="ViewItem()" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime-man actions-btn-prime3 margin-left-auto font-size-13px padding-left-5px padding-right-5px min-width-32px">
                            <i class="fa fa-ellipsis-h"></i>
                          </button>
                          <button class="btn font-size-13px actions-btn-prime  margin-left-5px">Cancel Voucher</button>

                        </td>





                      </tr>-->
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
 

</div>


